const TYPES = ['SUCCESS', 'INFO', 'WARNING', 'ERROR'];
const onKovNotificationRemoved = 'onKovNotificationRemoved';

class KovNotifications {
  constructor($scope) {
    'ngInject';
    this.$scope = $scope;
  }

  getIconClass(notification) {
    const notificationType = (notification.type || TYPES[3]).toLowerCase();

    switch (notificationType) {
      case 'error':
        return 'glyphicon glyphicon-exclamation-sign';
      case 'success':
        return 'glyphicon glyphicon-ok-sign';
      case 'info':
        return 'glyphicon glyphicon-question-sign';
      case 'warning':
        return 'glyphicon glyphicon-warning-sign';
    }
  }

  getStyleClass(notification) {
    let clazz = 'notification notification-' + (notification.type || TYPES[0]).toLowerCase();
    if (this.sFullScreenWidthUsed) {
      clazz += ' full-screen-width-is-used'
    }
    return clazz;
  }

  onClick(notification) {
    if (notification.key) {
      this.$scope.$emit(onKovNotificationRemoved, notification.key);
    }
  }
}

module.exports = {
  template: require('./kovNotifications.html'),
  controllerAs: 'ctrl',
  controller: KovNotifications,
  transclude: true,
  bindings: {
    sList: '<',
    sFullScreenWidthUsed: '<'
  }
};
